import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import {
        isDevBypass,
        getUserAllowedModules,
        canUserAccessModule,
        hasUserFullAccess,
        type Auth0User,
} from '../router/moduleGuard';

export function useModuleAccess() {
        const auth0 = useAuth0();

        const allowedModules = computed<string[]>(() => {
                const user = auth0.user.value as Auth0User | undefined;
                return getUserAllowedModules(user);
        });

        const canAccessModule = (moduleName: string): boolean => {
                const user = auth0.user.value as Auth0User | undefined;
                return canUserAccessModule(user, moduleName);
        };

        const hasFullAccess = computed(() => {
                const user = auth0.user.value as Auth0User | undefined;
                return hasUserFullAccess(user);
        });

        return {
                allowedModules,
                canAccessModule,
                hasFullAccess,
                isDevBypass,
        };
}
